import React from 'react'
import PropTypes from 'prop-types'

import Breadcrumbs from './../block/Breadcrumbs'
import WhiteBlockTitle from './../block/WhiteBlockTitle'
import Cards1 from './../block/Cards1'
import Advantages from './../block/AdvantagesWZ'
import WindowsBlock from './../block/WindowsBlock'
import Kontakti from './../block/Kontakti'
import GreenButton from './../block/GreenButton'
import FeedbackForm from './../block/FeedbackForm'

import styles from './../style/Prices.module.scss'

import { Container, Image } from 'react-bootstrap'

class Prices extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      active: 0,
      show_feedback: false,
      windows_block: {
        rimg: props?.data?.windows_block?.rimg,
        rimg_mob: props?.data?.windows_block?.rimg_mob,
        list: props?.data?.advantages.length > 0 ? props?.data?.advantages[0]?.list : []
      }
    }
  }

  showFeedback = () => {
    this.setState({ show_feedback: true });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  changeActive = ( k ) => {
    this.setState({
      active: k
    })
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  changeList = ( list ) => {
    const { windows_block } = this.state
    windows_block.list = list
    this.setState({ windows_block: windows_block });
  }

  render() {

    const { data, assets_path } = this.props,
    { active, show_feedback, windows_block } = this.state

    return (
      <>
        <Breadcrumbs items={data?.breadcrumbs || []} />
        <div className={styles.prices}>
          <Container>
            <WhiteBlockTitle
              title={data?.vnsshniyvid?.title}
              text={``}
            />
            <div className={styles.prices_content}>
              <div className={styles.cards}>
                {data?.vnsshniyvid?.list.map( ( elm, k ) => (
                  <div className={`${k == active ? styles.card_active : styles.card}`}>
                    <div className={styles.card_top}>
                      <div className={styles.card_title}>{elm.name}</div>
                      <div>{this.formatSlideNumber(k)}</div>
                    </div>
                    <div className={styles.card_text}>{elm.text}</div>
                  </div>
                ))}
              </div>
              <div className={styles.cards_icons}>
                {data?.vnsshniyvid?.list.map( ( elm, k ) => (
                  <div onClick={() => this.changeActive( k )} className={`${k == active ? styles.content_image_mob_icon_active : styles.content_image_mob_icon}`}>
                    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.49219 1.10547V13.8949" stroke="white" strokeLinecap="round"/>
                      <path d="M13.8945 7.49023L1.10506 7.49023" stroke="white" strokeLinecap="round"/>
                    </svg>
                  </div>
                ))}
              </div>
              <Image className='d-none d-lg-block' src={data?.vnsshniyvid?.image} width={430} height={406} alt={data?.vnsshniyvid?.title} />
              <Image className='d-lg-none' src={data?.vnsshniyvid?.image_mob} width={154} height={334} alt={data?.vnsshniyvid?.title} />
            </div>
          </Container>
        </div>
        <Cards1
          list={data?.priemushestva || []}
          cols={`prices`}
        />
        <Container>
          <div className={styles.hilevel}>
            <div className={styles.hilevel_row}>
              <div className={styles.b_icon}>
                <Image src={`/${assets_path}/images/voice-cricle.svg`} width={21} height={21} alt={`шум`} />
              </div>
              <div className={styles.title}>Высокий уровень шумо-теплоизоляции</div>
            </div>
            <div className={styles.hilevel_row}>
              <div>[GOODWIN]</div>
              <div className={styles.sep} />
              <GreenButton
                text={`Заказать бесплатный замер`}
                width={233}
                svg={(
                  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.8737 11.9173H8.1237C10.832 11.9173 11.9154 10.834 11.9154 8.12565V4.87565C11.9154 2.16732 10.832 1.08398 8.1237 1.08398H4.8737C2.16536 1.08398 1.08203 2.16732 1.08203 4.87565V8.12565C1.08203 10.834 2.16536 11.9173 4.8737 11.9173Z" stroke="#00C775" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9.75 3.25L3.25 9.75" stroke="#00C775" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M9.7487 5.41667V3.25H7.58203" stroke="#00C775" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M3.25 7.58398V9.75065H5.41667" stroke="#00C775" stroke-width="0.8" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                )}
                className={styles.button}
                action={() => this.showFeedback()}
              />
              <FeedbackForm
                title={`Заказать бесплатный замер`}
                text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
                btn={`Отправить`}
                data={[]}
                show={show_feedback}
                handleClose={() => this.closeFeedback()}
              />
            </div>
          </div>
        </Container>
        <Advantages
          advantages={data?.advantages || {}}
          blocks={`single`}
          changeList={this.changeList}
        />
        <WindowsBlock
          data={windows_block}
          margin={`top`}
        />
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
          cardsOnly={true}
        />
      </>
    )
  }
}

Prices.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

Prices.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default Prices